// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
const currentBuild = window.__ARTKIV_BUILD__;
const storedBuild = localStorage.getItem("artkiv_build");

if (storedBuild && storedBuild !== currentBuild) {
  localStorage.setItem("artkiv_build", currentBuild);
  window.location.reload(true);
} else {
  localStorage.setItem("artkiv_build", currentBuild);
}


root.render(<App />);

